import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=b1c8cd34&"
import script from "./ArticlePreview.vue?vue&type=script&lang=js&"
export * from "./ArticlePreview.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=b1c8cd34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports